
import { gsap } from "gsap";
import { OldEmitterConfig} from "pixi-particles";
import { ParticleController } from "./ParticleController";
import { StageLayer } from "@nolimitcity/slot-launcher/bin/StageLayer";
import { AssetLoader } from "@nolimitcity/slot-game/bin/asset/AssetLoader";
import { ParticleSettings } from './ParticleSettings';

export class ParticlesManager extends PIXI.Container implements StageLayer{

    private _bigWinParticle: ParticleController;
    private _bigWinParticle2: ParticleController;
    private _bigWinParticle3: ParticleController;
    private _normalWinParticle: ParticleController;
    private  assetLoader: AssetLoader;

    private allParticleControllers:ParticleController[] = [];
    public get bigWinParticles(): ParticleController { return this._bigWinParticle; }
    public get bigWinParticles2(): ParticleController { return this._bigWinParticle2; }
    public get bigWinParticles3(): ParticleController { return this._bigWinParticle3; }
    public get normalWinParticle(): ParticleController { return this._normalWinParticle; }

    constructor(assetLoader:AssetLoader) {
        super();

        this.name = "ParticlesManager";

        this.assetLoader = assetLoader;
        gsap.ticker.add(() => this.updateAll());
        this.initAnimations();
        
    }

    private updateAll():void{
        this.allParticleControllers = this.allParticleControllers.filter((pc) => pc.inGame);
        this.allParticleControllers.forEach((pc) => pc.update());
    }

    public createAnimation(layer:PIXI.Container,nameUpdate:string,texturePath:string, conf:OldEmitterConfig,loops?:boolean): ParticleController {
        const PC:ParticleController = new ParticleController(layer,nameUpdate+"particle",this.assetLoader.getTextures(texturePath), conf, loops);
        this.allParticleControllers.push(PC);
        return PC;
    }

    protected initAnimations():void {
        this._bigWinParticle = this.createAnimation(this,"BigWin","Wunder_Particle", ParticleSettings.Fountain,true)
        this._bigWinParticle2 = this.createAnimation(this,"BigWin2","Wheel_Particle", ParticleSettings.Fountain,true)
        this._bigWinParticle3 = this.createAnimation(this,"BigWin3","Cone_Particle", ParticleSettings.Fountain,true)

        this._normalWinParticle = this.createAnimation(this,"normalParticle","Cone_Particle", ParticleSettings.SplashMiddle,true)
    }

    public triggerWinSplash(isBigWin:boolean){
        this._normalWinParticle.setPos( new PIXI.Point(360, isBigWin ? 460 : 300 ));
        this._normalWinParticle.enableEmit(true);
    }
}